import { BlocksPage, FileList, ImageList, ImageListProvider, NotFound } from "@dgs/core";
import { Route, Routes } from "react-router";
import { aspectRatios } from "../contentManagement/aspectRatioOptions";

export const ContentManagementPage = () => {
	return (
		<Routes>
			<Route path="blocks/*" element={<BlocksPage />} />
			<Route
				path="images"
				element={
					<ImageListProvider>
						<ImageList aspectRatioOptions={aspectRatios} />
					</ImageListProvider>
				}
			/>
			<Route path="files/*" element={<FileList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
